import store from '../vuex/store'

/**
 * Legacy helpers — still used for many axios calls. Prefer `setupAxiosAuthInterceptor()` (main.js)
 * which overwrites `Authorization` on every request with `userManager.getUser().access_token` so
 * tokens stay fresh after `signinSilent()`. These values may lag Vuex until the interceptor runs.
 */
export function GetAuthorisationHeaderGroup(){
    var token = store.state.authentication.accessToken
    return { headers : buildAuthorisationHeader(token)}
}

export function GetBearerToken(){

    return "Bearer " + store.state.authentication.accessToken;
}

export function GetBearerHeader()
{
    var token = store.state.authentication.accessToken
    return buildAuthorisationHeader(token)
}

function buildAuthorisationHeader(token) {
    return {'Authorization': "Bearer " + token}
}